import { useEffect, useState } from "react";

import { getUserDetails } from "~/services/supervisor.services";

import LoadingIcon from "~/components/form/LoadingIcon";

import UserTable from "./table";
import Modal from "./modals/addUser";
const UserComponent = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userData, setUserData] = useState<any>(null);
  const handleClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const fetchData = async () => {
    const { data, status } = await getUserDetails();

    console.log(data);
    if (status) {
      setUserData((data as any)?.data);
    }
  };

  useEffect(() => {
    void fetchData();
  }, []);

  const handleDataUpdate = (updatedData: any[]) => {
    setUserData(updatedData);
  };
  return (
    <div className="">
      <button
        className="fixed z-10 bottom-4 right-4 w-12 h-12 bg-orange-500 text-white rounded-full text-2xl flex items-center justify-center shadow-lg focus:outline-none"
        onClick={handleClick}
      >
        +
      </button>
      <Modal
        onUserAdded={fetchData}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
      <div className="mb-4">
        <div className="flex justify-right items-center mb-3 ml-7">
          <h4 className="text-2xl font-semibold text-orange-500">
            User Management
          </h4>
        </div>
      </div>
      {userData != null ? (
        <>
          <div className="bg-neutral-100 rounded-lg">
            <div className="p-2">{<UserTable data={userData} onDataUpdate={handleDataUpdate} fetchData={fetchData} />}</div>
          </div>
        </>
      ) : <LoadingIcon/>}
    </div>
  );
};

export default UserComponent;
